<template>
  <nav v-if="show_cookie_bar" class="navbar fixed-bottom navbar-expand bg-body-tertiary">
    <div class="container-fluid">
      <div class="cookie-choice">

        <div @click="accept">
          <img :src="`${$imagePathBase}about/cookie.svg`" alt="cookie" class="cookie-image">We use cookies (the helpful kind)
          <div>
            <button class="btn btn-sm btn-accept" type="button">
              <img :src="`${$imagePathBase}win_icon-gold.svg`" alt="cookie" class="cookie-image"> sure, sounds great!
            </button>
          </div>
        </div>

        <div>
          <button class="btn btn-sm btn-learn-more" type="button" @click="show_cookie_modal=true">
            actually, tell me more...
          </button>
        </div>

      </div>
    </div>
  </nav>

  <GenericModal v-if="show_cookie_modal" @modal-closed="show_cookie_modal=false" class="cookie-modal">
    <template #header>
      <img :src="`${$imagePathBase}about/cookie.svg`" alt="cookie" class="modal-cookie-image"><span class="modal-header-text">Cookies</span>
    </template>

    <CookieSettings :modal="true"></CookieSettings>

<!--    <template #footer>-->
<!--    </template>-->

  </GenericModal>
</template>


<script>
import GenericModal from "@/components/modal/GenericModal.vue";
import CookieSettings from "@/components/about/CookieSettings.vue";
import analytics from "@/analytics";
import {EventBus} from "@/eventBus";

export default {
  name: "CookieBar",
  components: {GenericModal, CookieSettings},
  emits: ['visibility-update'],
  data() {
    return {
      show_cookie_bar: true,
      show_cookie_modal: false
    };
  },
  mounted() {
    this.udpateShowCookieBar();
    EventBus.on('analytics-tracking-preference-updated', () => {
      this.udpateShowCookieBar()
    });
  },
  methods: {
    udpateShowCookieBar() {
      //console.log(`udpateShowCookieBar()   hasOptedInToTracking=${analytics.hasOptedInToTracking()}  |  hasOptedOutOfTracking=${analytics.hasOptedOutOfTracking()}`);
      this.show_cookie_bar = !analytics.hasSetTrackingPreferences();
      this.$emit('visibility-update', this.show_cookie_bar);
    },

    accept() {
      //console.log('accept');
      analytics.optInToTracking();
    },
    decline() {
      //console.log('decline');
      analytics.optOutOfTracking();
    }

  }
}
</script>

<style>
* {
  --mol-cookiebar-height: calc(173px + env(safe-area-inset-bottom));
}
</style>

<style scoped>

  .navbar {
    border-top-style: solid;
    border-top-color: var(--bs-secondary);
    border-top-width: 1px;
    padding-top: 12px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
  }

  .navbar-nav {
    padding-left: 10px;
    padding-right: 10px;
  }

  .nav-item {
    display: inline-block;
  }

  .cookie-image {
    height: 40px;
    margin-right: 0.2em;
  }

  .cookie-choice {

    text-align: center;

    color: var(--mol-color-gold);
    font-weight: bold;

    margin-right: auto;
    margin-left: auto;

    .cookie-image {
      height: 40px;
      margin-right: 0.2em;
    }

    .btn-accept {

      margin: 0 auto 0.5em auto;
      width: 70%;


      font-weight: bold;
      color: inherit;
      border-width: 2px;
      border-color: var(--mol-color-gold);

      img {
        height: 2em;
      }

      &:hover {
        box-shadow: 0 0 0 1px var(--mol-color-gold);
      }
    }

    .btn-learn-more {
      height: 40px;
      width: 70%;
      font-style: italic;
      color: var(--bs-secondary-color);
      margin: 1em auto 0.5em auto;
      border: solid;
      border-width: 1px;
      border-color: var(--bs-secondary-color);

      &:hover {
        box-shadow: 0 0 0 1px slategray;
      }

    }

  }



  .cookie-modal {

    .modal-cookie-image {
      height: 40px;
      padding: 0px 5px 0px 5px;
      position: relative;
    }

    .modal-header-text {
      font-size: larger;
      font-weight: bold;
    }
  }


</style>